export default __webpack_public_path__ + "static/media/favicon.4e6b3491.ico";